interface FlagProps {
    name: string
    size?: number
    className?: string
}

export default function Flag({ name, size, className }: FlagProps) {
    return <img width={size ? size : 68} height={size ? size : 68} className={`${className}`} alt={name} src={require(`./flag/${name}.svg`)}/>
}
